import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ImportResultSummary } from '../hooks/useVehicleImport';

interface ImportResultDialogProps {
  open: boolean;
  status: 'completed' | 'failed';
  errorMessage: string | null;
  resultSummary: ImportResultSummary;
  onClose: () => void;
}

const ImportResultDialog: React.FC<ImportResultDialogProps> = ({
  open,
  status,
  errorMessage,
  resultSummary,
  onClose,
}) => {
  const isSuccess = status === 'completed';
  const { totalRows, created, updated, skipped, errors } = resultSummary;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{isSuccess ? 'Import Complete' : 'Import Failed'}</DialogTitle>
      <DialogContent>
        {isSuccess ? (
          <>
            <DialogContentText sx={{ mb: 2 }}>
              {totalRows} row{totalRows === 1 ? '' : 's'} processed — {created} created, {updated} updated, {skipped}{' '}
              skipped.
            </DialogContentText>
            {errors.length > 0 ? (
              <>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Skipped rows
                </Typography>
                <TableContainer component={Box} sx={{ maxHeight: 360, border: '1px solid rgba(0, 0, 0, 0.12)' }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Row</TableCell>
                        <TableCell>VIN</TableCell>
                        <TableCell>Stock</TableCell>
                        <TableCell>Field</TableCell>
                        <TableCell>Message</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {errors.map(error => (
                        <TableRow
                          key={`${error.row ?? 'row'}-${error.vin}-${error.stock}-${error.field}-${error.message}`}
                        >
                          <TableCell>{error.row ?? '—'}</TableCell>
                          <TableCell>{error.vin || '—'}</TableCell>
                          <TableCell>{error.stock || '—'}</TableCell>
                          <TableCell>{error.field || '—'}</TableCell>
                          <TableCell>{error.message}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : null}
          </>
        ) : (
          <DialogContentText>{`Import failed: ${errorMessage || 'An unknown error occurred.'}`}</DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportResultDialog;
